import '../static/Button.css';
import React__default from "react";
import clsx from "clsx";
import Link from "next/link.js";
import { u as useTagName } from "./useTagName.COq0HFfN.mjs";
import { a as addRelAndTarget } from "./addRelAndTarget.DDvAIEJJ.mjs";
import { S as SvgSpinnerAnimated1Px } from "./spinner-animated-1px.DkxgkEsL.mjs";
const button = `_button_72a8ecf`;
const rounded = `_rounded_71fc840`;
const xs = `_xs_42e46fc`;
const text = `_text_79734a7`;
const sm = `_sm_6eb9175`;
const md = `_md_9c39f2a`;
const lg = `_lg_a8c9500`;
const primary = `_primary_00d2a3e`;
const secondary = `_secondary_a2400d3`;
const white = `_white_3070e3b`;
const tertiary = `_tertiary_2f737a4`;
const transparent = `_transparent_636ecdf`;
const content = `_content_1d6b1da`;
const loader = `_loader_779f5db`;
const styles = { button, rounded, xs, text, sm, md, lg, primary, secondary, white, tertiary, transparent, content, loader };
const BUTTON_SIZES = ["md", "xs", "sm", "lg"];
const BUTTON_VARIANTS = [
  "primary",
  "secondary",
  "tertiary",
  "white",
  "transparent",
  "text"
];
function isText(variant) {
  return variant === "text";
}
const ButtonContent = ({
  children,
  loading
}) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("span", { className: styles.content }, children), loading && /* @__PURE__ */ React__default.createElement(SvgSpinnerAnimated1Px, { "data-testid": "ui-button-loader", className: styles.loader }));
const ButtonDefault = React__default.forwardRef(
  ({ as = "button", children, loading, type, variant, ...props }, ref) => {
    const Component = useTagName(as || "button");
    return /* @__PURE__ */ React__default.createElement(Component, { ref, type: as === "button" ? type : void 0, ...props }, /* @__PURE__ */ React__default.createElement(ButtonContent, { ...{ children, loading, variant } }));
  }
);
const Button = React__default.forwardRef(
  ({
    className,
    children,
    disabled,
    loading,
    type = "button",
    variant = "primary",
    size = "md",
    rounded: rounded2 = false,
    ...props
  }, ref) => {
    const buttonSize = isText(variant) ? "md" : size;
    const defaultProps = {
      "data-ui-button": true,
      "aria-busy": loading,
      className: clsx(
        styles.button,
        styles[variant],
        {
          [styles.rounded]: rounded2 && !isText(variant),
          [styles[buttonSize]]: !rounded2
        },
        className
      ),
      ref,
      ...props
    };
    if (props == null ? void 0 : props.href) {
      const { target } = props;
      return /* @__PURE__ */ React__default.createElement(
        Link,
        {
          "aria-disabled": disabled,
          ...defaultProps,
          ...addRelAndTarget(target)
        },
        /* @__PURE__ */ React__default.createElement(ButtonContent, { ...{ children, loading } })
      );
    }
    return /* @__PURE__ */ React__default.createElement(
      ButtonDefault,
      {
        ...{
          children,
          disabled,
          loading,
          type,
          ...defaultProps
        }
      }
    );
  }
);
export {
  BUTTON_SIZES as B,
  BUTTON_VARIANTS as a,
  Button as b
};
//# sourceMappingURL=Button.hIh6dJaA.mjs.map
